import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  label,
  error,
  icon,
  ...props
}, ref) => {
  return <div className="w-full space-y-1.5" data-id="element-281">
        {label && <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-slate-700" data-id="element-282">
            {label}
          </label>}
        <div className="relative" data-id="element-283">
          {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-284">
              {icon}
            </div>}
          <input className={cn('flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-50', icon && 'pl-10', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-285" />
        </div>
        {error && <p className="text-xs text-red-500" data-id="element-286">{error}</p>}
      </div>;
});
Input.displayName = 'Input';